import { EChannel, IPageParam } from '@core/main/types';

export interface IPaycodeListParams {
  /** 收款码名称 */
  payCodeName?: string;
  /** 收款码编号 */
  payCodeNo?: string;
  /** 收款码类型 */
  payCodeType?: string;
  /** 收款码状态*/
  status?: string;
  /** 当前页码（从1开始） */
  page?: number;
  /** 每页显示条数 */
  size?: number;
  /** 子公司名称*/
  companyName?: string;
  companyId?: number;
}

export interface IPaycodePage {
  /** 收款码名称 */
  payCodeName: string;
  /** 收款码编号 */
  payCodeNo: string;
  /** 收款码类型 */
  payCodeType: number;
  /** 收款码状态*/
  status: string;
  /** 收款码id */
  payCodeId: number;
  /** 门店id */
  storeId: number;
  /** 门店名称 */
  storeName: string;
  /** 员工id */
  staffId: number;
  /** 员工姓名 */
  staffName: string;
  /** 企业简称 */
  shortName: string;
  /** 收款码归属 */
  belongName: string;

  /** 二维码 */
  qrUrl: string;
  /** 是否获取配置 */
  configObtain: number;
  /** 姓名配置 */
  configName: number;
  /** 手机号配置 */
  configPhone: number;
  /** 备注配置 */
  configMemo: number;
  /** 子公司名称 */
  companyName: string;
}

export interface IPaycodeAddParams {
  /** 收款码名称 */
  payCodeName: string;
  /** 收款码类型 */
  payCodeType: number;
  /** 门店id*/
  storeId: number;
  /** 员工id*/
  staffId: number;
  /** 公司id */
  companyId?: string;
  /**
   * 收款拆分
   * @description 'NO_SPLIT'时候不展示 拆分起步金额 字段
   */
  amountSplitStrategy: 'NO_SPLIT' | 'PRESET_AMOUNT_SPLIT';
  /** 拆分起步金额 */
  amountSplitThreshold?: number;
}

/** 二维码状态 */
export enum EPayCodeStatus {
  /** 停用 */
  Disabled = 0,
  /** 启用 */
  Enabled = 1,
}

export const payCodeStatusLabel = {
  [EPayCodeStatus.Disabled]: '停用',
  [EPayCodeStatus.Enabled]: '启用',

};

export interface IPOSTerminalListParams {
  /** 当前页码（从1开始） */
  page: number;
  /** 每页显示条数 */
  size: number;
  companyId?: string;
}

export interface IPOSTerminalItem {
  /** id */
  id: number;
  /** 门店ID */
  storeId: number;
  /** 门店名称 */
  storeName: string;
  /** 网点编号 */
  shopNo: string;
  /** 终端序列号 */
  serialNo: string;
  /** 终端号 */
  terminalNo: string;
  /** 终端名称 */
  terminalName: string;
  /** 创建时间 */
  createTime: string;
}

export interface IPOSTerminalAddParams {
  /** id */
  id: number;
  /** 门店ID */
  storeId: number;
  /** 终端序列号 */
  serialNo: string;
  /** 终端名称 */
  terminalName: string;
  companyId?: string;
  companyName?: string;
}

export interface IEasyPayParams extends IPageParam {
  /** 收款码编号 */
  paycodeNo?: string;
  /** 收款码名称	*/
  paycodeName?: string;
  /**  状态 ENABLED：启用 DISABLED：禁用 */
  status?: EEasyPayStatus;
  /** 门店ID */
  storeId?: number;
  /** 企业ID */
  companyId?: number;
  /** 是否是门店收款码。默认：false */
  fromStore?: boolean;
}

export interface IEasyPayItem {
  /** */
  id: number;
  /** 支付通道｜YEEPAY：易宝支付 */
  channel: EChannel;
  /** 收款码编号 */
  paycodeNo: string;
  /** 收款码名称	*/
  paycodeName: string;
  /** 绑定 POS 终端序列号 */
  boundPosSerial: string;
  /** 二维码地址 */
  qrUrl: string;
  /**  状态 ENABLED：启用 DISABLED：禁用 */
  status: EEasyPayStatus;
  /** 门店ID */
  storeId: number;
  /** 门店编号 */
  storeNo: string;
  /** 门店名称 */
  storeName: string;
  /** 企业ID */
  companyId: number;
  /** 企业名称 */
  companyName: string;
}

export interface IEasyPayCreateParams {
  /** */
  id?: number;
  /** 支付通道｜YEEPAY：易宝支付 */
  channel: EChannel;
  /** 收款码编号 */
  paycodeNo: string;
  /** 收款码名称	*/
  paycodeName: string;
  /** 绑定 POS 终端序列号 */
  boundPosSerial?: string;
  /** 二维码地址 */
  qrUrl: string;
  /** 门店ID */
  storeId: number;
  /** 企业ID */
  companyId: number;
}

/** 易缴费状态 */
export enum EEasyPayStatus {
  /** 停用 */
  DISABLED = 'DISABLED',
  /** 启用 */
  ENABLED = 'ENABLED',
}

export const easyPayStatusLabel = {
  [EEasyPayStatus.DISABLED]: '停用',
  [EEasyPayStatus.ENABLED]: '启用',
};
